import { createContext, useContext } from "react";
import type { AuthState } from "../types";

export interface AuthContextValue extends AuthState {
  loading: boolean;
  error: string | null;
  /** A viewer session (role "viewer"): mutating controls are hidden; the server refuses them. */
  viewer: boolean;
  login: (username: string, password: string) => Promise<void>;
  logout: () => Promise<void>;
}

export const AuthContext = createContext<AuthContextValue | null>(null);
export function useAuth() {
  const value = useContext(AuthContext);
  if (!value) throw new Error("useAuth must be used inside AuthProvider");
  return value;
}

/**
 * Whether the session may only read. Outside an AuthProvider (isolated component tests) it is an
 * operator: hiding a control is presentation only, the server's allowlist is the authority.
 */
export function useViewer(): boolean {
  return useContext(AuthContext)?.viewer ?? false;
}
